import withUser from '~lib/common/hoc/withUser';

import DevEnvironmentsGuard from './DevEnvironmentsGuard';

export default withUser()(DevEnvironmentsGuard);
